export default {
    BUSINESS: 'business',
    PERSONAL: 'personal',
    STUDENT: 'student',
};
